import { useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const { slides, padding, colorbg, title, url, positiontitle, container } =
    attributes;
  const blockProps = useBlockProps.save({
    className: `cattwo ${colorbg ? 'sectiongray' : ''} ${padding}`,
  });

  const Tag = title ? 'section' : 'div';

  return (
    <>
      {slides && (
        <Tag {...blockProps}>
          <div className={container ? '' : 'container'}>
            {title && (
              <div class="row">
                <div className={`globaltitle ${positiontitle}`}>
                  <h2>{title}</h2>
                  {url && (
                    <a href={url} class="btn btn-square btn-mini btn-url">
                      Смотреть все изделия
                    </a>
                  )}
                </div>
              </div>
            )}
            <div class="row">
              <div class="col">
                <div class="swiper js-slider-cattwo">
                  <div class="swiper-wrapper">
                    {slides.map((slide, index) => (
                      <div class="swiper-slide">
                        <a href={slide.url} class="cattwo__item">
                          <div class="cattwo__item-img">
                            <img
                              loading="lazy"
                              src={slide.image.url}
                              alt={slide.image.alt}
                              height={slide.image.height}
                              width={slide.image.width}
                            />
                          </div>
                          <div class="cattwo__item-title">
                            <h3>{slide.title}</h3>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div>
              </div>
            </div>
          </div>
        </Tag>
      )}
    </>
  );
}
